/**
 *
 * Asynchronously loads the component for InactivityModal
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
